import { Trans } from 'react-i18next'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { ColumnAdapter, ColumnConditionValue } from '@makyoapp/makyo-common'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { useUpdateCompSettingValue } from '@/hooks/useUpdateCompSettings'
import { BuilderComponentSetting } from '@/shared/builder'
import { ColumnConditionRepeaterV3 } from '@/components/Builder/ColumnConditionRepeaterV3'

interface ColumnFilterFieldSettingProps {
  id: string
  settingId: string
  value: any
  columnFilterSettings: BuilderComponentSetting['columnFilterSettings']
}

const ColumnFilterFieldSetting = ({ id, settingId, value, columnFilterSettings }: ColumnFilterFieldSettingProps) => {
  const tableSourceId = columnFilterSettings?.tableSourceId
  const columnSourceId = columnFilterSettings?.columnSourceId

  const { tables, tablesMap } = useDbClientContext()
  const { activeComponent, activeLayerContainer } = useActiveLayerContext()
  const updateValue = useUpdateCompSettingValue(id)

  const sourceValue: undefined | string | { table: string; columns: string[] } =
    activeComponent && tableSourceId
      ? (activeLayerContainer?.elementSettings[activeComponent.id]?.[tableSourceId] as
          | {
              table: string
              columns: string[]
            }
          | string)
      : undefined

  const isStr = typeof sourceValue === 'string'

  const source = {
    table: '',
    columns: [] as string[],
  }

  if (isStr) {
    source.table = sourceValue
  } else {
    source.table = sourceValue?.table ?? ''
    source.columns = sourceValue?.columns ?? []
  }

  const sourceColumnValue: undefined | string[] =
    activeComponent && columnSourceId
      ? (activeLayerContainer?.elementSettings[activeComponent.id]?.[columnSourceId] as string[])
      : undefined

  if (sourceValue && !source.columns && sourceColumnValue) {
    source.columns = sourceColumnValue
  }

  const table = tables?.find((tb) => tb.id === source.table)

  const tableColumns = (tablesMap.get(source.table)?.GetColumns() ?? []).filter(
    (c) =>
      ![
        ColumnTypes.Connection,
        ColumnTypes.RichText,
        ColumnTypes.RowID,
        // ColumnTypes.Icon,
        ColumnTypes.Address,
        ColumnTypes.Slug,
        ColumnTypes.Array,
        ColumnTypes.QRCode,
        ColumnTypes.ImageArray,
        ColumnTypes.Barcode,
        ColumnTypes.AISEO,
        ColumnTypes.AITextProcessing,
      ].includes(c.type)
  )

  const columnOptions = [{ id: '_id', name: 'Row ID', type: ColumnTypes.RowID } as ColumnAdapter, ...tableColumns]

  return table && tableColumns ? (
    <div className='w-full'>
      {/* <div className='pb-4'>
        <Trans>Show items</Trans>
      </div> */}
      <ColumnConditionRepeaterV3
        id={settingId}
        value={value as ColumnConditionValue}
        onChange={updateValue}
        colOptions={columnOptions}
        tables={tables}
        table={table}
      />
    </div>
  ) : null
}

export default ColumnFilterFieldSetting
